import React, { Component } from 'react';
import bgImg from '../../images/MobileFooter.png';
import bgBlueGradient from '../../images/Footer.png';
import { NavLink } from 'react-router-dom';

import {
  FOOTER_LINKS as footerLinks,
  SOCIAL_LINKS as socialLinks,
  SOCIAL_LINKS_EVEREST as everestSocialLinks
} from '../../constants/navigation';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '../utility/Button';
import {withRouter} from 'react-router-dom';
import chatButton from '../../images/icons/button_gif.gif';

const bgStyle = {
  backgroundImage: `url("${bgImg}")`
};
const bgEverestStyle = {
  backgroundImage: 'unset',
  backgroundColor: 'white'
};

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      showPopup: false,
      popupStory: null,
      isEverest: (window.location.pathname === '/getaways/everest/' || window.location.pathname === '/getaways/everest') ? true : false
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (window.location.pathname === '/getaways/everest/' || window.location.pathname === '/getaways/everest'){
        this.setState({isEverest: true});
      }
      else{
        this.setState({isEverest: false});
      }
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { t } = this.props;
    let csUrl = 'mailto:sdacford@simedarby.com';
    const isMobile = this.state.width <= 768;
    return (
      <>
        {(this.state.isEverest) ?
          (
            <footer className='fe-footer everest' style={bgEverestStyle}>
              <div className='fe-footer-overlay' />
              <div className='container'>
                <div className='fe-footer-chat'>
                  <div className='fe-chat-text'>The Everest Milestone will be launched soon.<br/>Watch this space for updates.</div>
                  {/* <Button alt className='fe-chat-button' onClick={()=> window.open('https://wa.me/60192041200', '_blank')}>
                    Let's Chat
                  </Button> */}
                  {/* <img className='fe-chat-button' src={chatButton} alt={'Talk with us'}
                    onClick={()=> window.open('https://wa.me/60192041200', '_blank')}
                  /> */}
                </div>


                <nav className='fe-footer-social-links'>
                  <span>{t('nav:follow')}</span>
                  {everestSocialLinks.map((link, idx) => (
                    <a
                      key={idx}
                      href={link.url}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <img
                        onMouseOver={e => (e.currentTarget.src = link.iconAlt)}
                        onMouseLeave={e => (e.currentTarget.src = link.icon)}
                        src={link.icon}
                        alt={link.name}
                      />
                    </a>
                  ))}
                </nav>

                <div className='fe-footer-content'>

                  {/* <nav className='fe-footer-links'>
                    {footerLinks.map((link, idx) => (
                      <NavLink key={idx} exact to={link.url} activeClassName='active'>
                        {t(`nav:${link.name}`)}
                      </NavLink>
                    ))}
                  </nav> */}

                  <div className='fe-footer-sdac'>
                    <div className='fe-footer-contact'>
                      <div className='fe-footer-title'>
                        Sime Darby Auto ConneXion Sdn Bhd (68602-V)
                      </div>
                      {/* <div className="fe-footer-line">1-800-18-1828</div> */}
                      {/* <div className='fe-footer-line'>
                        <a
                          className='fe-footer-cs'
                          href='https://wa.me/60192041200'
                          target='_blank'
                        >
                          WhatsApp Chat @ 019-2041200
                        </a>
                      </div> */}

                      <div className='fe-footer-line'>
                        Block 2, Pusat Automotif Sime Darby
                        <br />
                        No. 6, Jalan PJU 1A/7, Ara Damansara
                        <br />
                        47301 Petaling Jaya, Selangor, Malaysia
                      </div>
                      <div className='fe-footer-line'>
                        {/* <a className='fe-footer-cs' href={csUrl}>
                          sdacford@simedarby.com
                        </a> */}
                        019-204 1200
                      </div>
                    </div>
                    <p className='fe-footer-copyright'>
                      {t('nav:ownedBy', {
                        sdac: '© Sime Darby Auto ConneXion Sdn Bhd'
                      })}
                    </p>
                  </div>
                </div>
              </div>
            </footer>
          ) :
          (
            <footer className='fe-footer'>
              <div className='fe-footer-overlay' />
              <div className='container'>
                <nav className='fe-footer-social-links'>
                  <span>{t('nav:follow')}</span>
                  {socialLinks.map((link, idx) => (
                    <a
                      key={idx}
                      href={link.url}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {
                        (isMobile) ?
                          (
                            <img
                              src={link.icon}
                              alt={link.name}
                            />
                          ) :
                          (
                            <img
                              onPointerOver={e => (e.currentTarget.src = link.iconAlt)}
                              onPointerLeave={e => (e.currentTarget.src = link.icon)}
                              src={link.icon}
                              alt={link.name}
                            />
                          )
                      }
                    </a>
                  ))}
                </nav>
                <div className='fe-footer-content'>
                  <nav className='fe-footer-links'>
                    {footerLinks.map((link, idx) => (
                      <NavLink key={idx} exact to={link.url} activeClassName='active'>
                        {t(`nav:${link.name}`)}
                      </NavLink>
                    ))}
                  </nav>
                  <div className='fe-footer-sdac'>
                    <div className='fe-footer-contact'>
                      <div className='fe-footer-title'>
                        Sime Darby Auto ConneXion Sdn Bhd (68602-V)
                      </div>
                      {/* <div className="fe-footer-line">1-800-18-1828</div> */}
                      {/* <div className='fe-footer-line'>
                        <a
                          className='fe-footer-cs'
                          href='https://wa.me/60192041200'
                          target='_blank'
                        >
                          WhatsApp Chat @ 019-2041200
                        </a>
                      </div> */}

                      <div className='fe-footer-line'>
                        Block 2, Pusat Automotif Sime Darby
                        <br />
                        No. 6, Jalan PJU 1A/7, Ara Damansara
                        <br />
                        47301 Petaling Jaya, Selangor, Malaysia
                      </div>
                      <div className='fe-footer-line'>
                        {/* <a className='fe-footer-cs' href={csUrl}>
                          sdacford@simedarby.com
                        </a> */}
                        019-204 1200
                      </div>
                    </div>
                    <p className='fe-footer-copyright'>
                      {t('nav:ownedBy', {
                        sdac: '© Sime Darby Auto ConneXion Sdn Bhd'
                      })}
                    </p>
                  </div>
                </div>
              </div>
            </footer>
          )
        }
      </>
    );
  }
}

Footer.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(withTranslation()(Footer));
